import * as actionTypes from "./ActionTypes";
import Axios from "../../axios-instance";

// FETCH BOOKS

export const initBookFetching = () => {
  return {
    type: actionTypes.INIT_BOOK_LOADING,
  };
};

export const storeFetchedBooks = (books) => {
  return {
    type: actionTypes.FETCH_BOOKS,
    books: books,
  };
};

export const storeGoogleFetchedBooks = (books,resData) => {
  return {
    type: actionTypes.FETCH_GOOGLE_BOOKS,
    books: books,
    totalPage: resData.last_page,
  };
};

export const fetchBooks = () => {
  return (dispatch) => {
    dispatch(initBookFetching());
    Axios.get("/get/vk/all/books").then((response) => {
      dispatch(storeFetchedBooks(response.data));
    });
  };
};

export const fetchGooglePlayBooks = () => {
  return (dispatch) => {
    dispatch(initBookFetching());
    Axios.get("/get/google/play/store/books").then((response) => {
      dispatch(storeGoogleFetchedBooks(response.data,response.data));
    });
  };
};

export const GetBookByInputType = (bookType) => {
  return {
    type : actionTypes.GET_BOOK_BY_INPUT_TYPE,
    bookType : bookType
  }
}

// FETCH BOOK DETAIL

export const initBookDetailFetching = () => {
  return {
    type: actionTypes.INIT_FETCH_BOOK_DETAIL,
  };
};

export const storeFetchedBookDetail = (bookDetail) => {
  return {
    type: actionTypes.FETCH_BOOK_DETAIL,
    bookDetail: bookDetail,
  };
};

export const fetchBookDetail = (id) => {
  return (dispatch) => {
    dispatch(initBookDetailFetching());
    Axios.get(`/get/vk/book/details/${id}`).then((response) => {
      dispatch(storeFetchedBookDetail(response.data));
    });
  };
};

//FILTER BOOK

export const initFilter = () => {
  return {
    type: actionTypes.INIT_FILTER_ITEM,
  };
};

export const setFilter = (filterData, restData) => {
  return {
    type: actionTypes.FILTER_ITEM,
    filterData: filterData,
    totalPage: restData.last_page,
  };
};

export const filterBooks = (datatToBeFiltered) => {
  return (dispatch) => {
    dispatch(initFilter());
    Axios.post(`/get/vk/books/filtered`, datatToBeFiltered).then((response) => {
      dispatch(setFilter(response.data.data, response.data));
    });
  };
};

export const getSelectedFilters = (filterData) => {
  return {
    type: actionTypes.GET_SELECTED_FILTERS,
    filterData: filterData,
  };
};

export const initPublishWithus = () => {
  return {
    type: actionTypes.INIT_PUBLISH_WITH_US,
  };
};

export const getPublishWithUs = (userData) => {
  return {
    type: actionTypes.PUBLISH_WITH_US,
    userData: userData,
  };
};

export const publishWithUsErrorHandler = () => {
  return {
    type: actionTypes.PUBLISH_WITH_US_ERROR_HANDLER,
  };
};
export const publishWithUs = (postUserData) => {
  return (dispatch) => {
    dispatch(initPublishWithus());
    Axios.post("create/vk/publish/with/us", postUserData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        dispatch(getPublishWithUs(response.data));
      })
      .catch((err) => {
        dispatch(publishWithUsErrorHandler());
      });
  };
};

export const initGetSampleCopy = () => {
  return {
    type: actionTypes.INIT_GET_SAMPLE_COPY,
  };
};

export const GetSampleCopyErrorHandler = () => {
  return {
    type: actionTypes.GET_SAMPLE_COPY_ERROR_HANDLER,
  };
};

export const GetSampleCopyData = (response) => {
  return {
    type: actionTypes.GET_SAMPLE_COPY,
    success: response,
  };
};

export const GetSampleCopy = (payload) => {
  return (dispatch) => {
    dispatch(initGetSampleCopy());
    Axios.post("create/vk/sample/request", payload)
      .then((response) => {
        dispatch(GetSampleCopyData(response.data));
      })
      .catch((err) => {
        dispatch(GetSampleCopyErrorHandler());
      });
  };
};

export const initGetBookByType = (textbook, collegeBooks, samplePapers) => {
  return {
    type: actionTypes.GET_BOOK_BY_TYPE,
    textbook: textbook,
    collegeBooks: collegeBooks,
    samplePapers: samplePapers,
  };
};

export const GetBookByType = () => {
  return (dispatch) => {
    Axios.get("get/vk/books/home").then((response) => {
      dispatch(
        initGetBookByType(
          response.data.class_books,
          response.data.college_books,
          response.data.xamidea
        )
      );
    });
  };
};
